import Swiper from "swiper/bundle";

new Swiper(".swiper", {
  direction: "horizontal",
  loop: true,
  // slidesPerView: 1,
  slidesPerView: "auto",
  // loopedSlides: 1,
  // slidesPerGroup: 3,

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  // breakpoints: {
  //   641: {
  //     slidesPerView: 3,
  //     spaceBetween: 10,
  //   },
  // },
});
